export const Config= {
    baseUrl: 'https://ec8c4kw8ooo0sgc0s08cwso8.93.127.185.38.sslip.io/api/',
    baseImageUrl: 'https://ec8c4kw8ooo0sgc0s08cwso8.93.127.185.38.sslip.io/api/get-file',
};